export const BONUS_SCORE = 'BonusScore';
